import { CommonModule } from '@angular/common';
import {ChangeDetectorRef, Component, Inject, Input} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {pluralize} from "../../../pipes/pluralize/pluralize";
import {TemplateReplacePipe} from "../../../pipes/trmplate-replace/template-replace.pipe";
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../../../config/hotel-tours-list-page.config";

@Component({
  selector: 'app-filter-nights',
  templateUrl: environment.mobile ? './filter-nights.component.mobile.html' : './filter-nights.component.html',
  styleUrls: environment.mobile ? ['./filter-nights.component.mobile.scss'] : ['./filter-nights.component.scss'],
  imports: [CommonModule, TemplateReplacePipe],
  standalone: true
})
export class FilterNightsComponent {
  @Input() isActive = false;
  @Input() viewValue!: string;
  @Input() filterValue!: number;
  @Input() count!: number;
  messages: any = {};

  constructor(@Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig) {
    this.messages = {
      'countTours': '{{countToursVal}} {{countToursText}}',
      'countDays': '{{countDaysVal}} {{countDaysText}}',
    };
  }

  countToursMapping(countTours) {
    return {
      'countToursVal': countTours,
      'countToursText': pluralize(countTours, this.hotelToursPageConfig.translates.plurals.pluralTours),
    }
  }

  countDaysMapping(countDays) {
    return {
      'countDaysVal': countDays,
      'countDaysText': pluralize(countDays, this.hotelToursPageConfig.translates.plurals.daysPlural),
    }
  }
}
